module.exports = __webpack_public_path__ + "img/金属材料学3_6.4c449c70.png";